import { render, staticRenderFns } from "./PortalLayoutView.vue?vue&type=template&id=d58dc202"
import script from "./PortalLayoutView.vue?vue&type=script&lang=ts"
export * from "./PortalLayoutView.vue?vue&type=script&lang=ts"
import style0 from "./PortalLayoutView.vue?vue&type=style&index=0&id=d58dc202&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports